import { useCallback } from 'react';
import { AModal } from '../../../../components';
import { useToast } from '../../../../hooks/toast';
import { IProcedureInsert } from '../../../../shared/interfaces';
import { Typography } from 'antd';
import { deleteTreatmentItem } from '../../../../http';

interface IRemoveProcedureProps {
  open: boolean;
  close: () => void;
  code: number | null;
  procedureInsert: IProcedureInsert;
  setProceduresInsert: React.Dispatch<React.SetStateAction<IProcedureInsert[]>>;
}

const RemoveProcedures: React.FC<IRemoveProcedureProps> = ({
  open,
  close,
  code,
  procedureInsert,
  setProceduresInsert,
}) => {
  const { addToast } = useToast();
  const { Text } = Typography;

  const deleteProcedure = useCallback(async () => {
    if (code) {
      await deleteTreatmentItem(procedureInsert.id)
        .then(() => {
          addToast({
            type: 'success',
            title: 'Sucesso',
            description: 'Procedimento removido',
          });
          setProceduresInsert((state) =>
            state.filter((x) => x.id !== procedureInsert.id),
          );
          close();
        })
        .catch((error) => {
          addToast({
            type: 'error',
            title: 'Erro',
            description: error.response.data.error ?? 'Erro ao deletar.',
          });
        });
    } else {
      setProceduresInsert((state: IProcedureInsert[]) =>
        state.filter((x) => x.id !== procedureInsert.id),
      );
      close();
    }
  }, [addToast, close, code, procedureInsert, setProceduresInsert]);

  return (
    <AModal
      open={open}
      close={close}
      title="Remover procedimento"
      onOk={() => deleteProcedure()}
      okText="Sim"
      cancelText="Não"
    >
      <Text>Tem certeza que deseja remover o procedimento?</Text>
    </AModal>
  );
};

export default RemoveProcedures;
